import React from 'react';
import './helpCenter.scss';
import { Outlet } from 'react-router-dom';

export default function HelpCenter() {
  return (
    <main className="help__center">
      <div>
        <Outlet />
        <footer className="help__center__footer">
          <div className="footer__content">
            <h2>Need more help?</h2>
            <p>
              If you are experiencing issues or have questions about using our
              product, please review our FAQ, visit our knowledge base, or
              contact our support team.
            </p>
            <ul>
              <li>
                <strong>Support Email:</strong>{' '}
                <a href="mailto:support@sastech.no">support@sastech.no</a>
              </li>
            </ul>
            <small>
              Our support team is available Monday to Friday, 8 AM to 4 PM
              (Europe/Oslo). We strive to respond to all inquiries within 12
              hours on business days.
            </small>
          </div>
        </footer>
      </div>
    </main>
  );
}
